// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__ZVA8N","cont":"styles_cont__wERXY"};